import DeliveryOption from '@/controllers/options/DeliveryOption';
import DeliveryOptionConstants from '@/controllers/options/DeliveryOptionConstants';
import DeliveryOptionsProvider from '@/models/DeliveryOptionsProvider';
import IOptionHandler from './IOptionHandler';

class ProctorReleaseOptionHandler implements IOptionHandler {
  execute(provider: DeliveryOptionsProvider, map: Map<string, unknown>): void {
    if (map.get(DeliveryOptionConstants.PROCTOR_RELEASE)) {
      const deliveryOption: DeliveryOption = new DeliveryOption(DeliveryOptionConstants.PROCTOR_RELEASE);
      deliveryOption.addSetting('value', 'true');
      provider.addDeliveryOption(deliveryOption);
    }
  }
}

export default ProctorReleaseOptionHandler;
